<template>
<div class="tg-panel pop pos-f top0 bottom0 left0 right0" :class="themeClass" v-if="show" @click="hidePanel">
	<div class="tg-panel_container bg-white pos-f bottom0 left0 right0" style="min-height: 38%;"
		 @click.stop="disabledClick">
		<div class="tg-panel_main">
			<p class="tg-panel_title bg-white text-center text-dark fs-20 paddingh30 paddingt30 paddingb10" style="visibility: hidden;" v-text="title"></p><!-- 占位用 -->
			<slot></slot>
		</div>
		<p class="tg-panel_title pos-a top0 left0 right0 bg-white text-left text-black fs-20 paddingh30 paddingt30 paddingb10 text-center"
		   v-text="title"></p>
		<i class="tg-panel_closeIcon icon icon-close pos-a right20 top30 fs-20 text-light" @click="hidePanel" :data-scp="closeIconScp"></i>
		<div class="tg-panel_ok hei flex-container pos-f bottom0 left0 box-container text-white fs-15 bg-red"
			 :data-scp="okScp"
			 @click="hidePanel" >确认</div>
	</div>
</div>
</template>

<script>
export default {
	props: {
		showState: {
			type: Boolean
			, default: false
		}
		, theme: {
			type: Number
			, default: 0
		}
		, title: {
			type: String
			, default: ''
		}
		, panelName: {
			type: String
			, default: ''
		}
		, closeIconScp: {
			type: String
			, default: ''
		}
		, okScp: {
			type: String
			, default: ''
		}
	}
	, data(){
		return {
			show: this.showState
			, themeList: {
				'0': 'theme0'		// 右上角有关闭 X 按钮，底部没有确认按钮，高度 61.8%
				, '1': 'theme1'		// 右上角没有关闭 X 按钮，底部有确认按钮，高度 61.8%
				, '2': 'theme2'		// 右上角有关闭 X 按钮，底部没有确认按钮，最小高度 38%
				, '3': 'theme3'		// 右上角没有关闭 X 按钮，底部有确认按钮，最小高度 38%
				, '4': 'theme4'		// 右上角有关闭 X 按钮，底部有确认按钮，高度 78%
			}
		};
	}
	, watch: {
		showState(newVal){
			this.show = newVal
		}
	}
	, computed: {
		themeClass(){
			return this.themeList[this.theme];
		}
	}
	, methods: {
		hidePanel(){
			this.show = false;
			this.$dispatch('closePanel', this.panelName, this.show);
		}
		, disabledTouchMove(){}
		, disabledClick(){}
	}
};
</script>
<style lang="scss">
.pop{
	width:100%;
	height:100%;
	background-color: rgba(0,0,0,.6);
	z-index:8;
}
.pop .hei{
	height:1.32rem;
	line-height:1.32rem;
}
.tg-panel.theme0 .tg-panel_ok,
.tg-panel.theme2 .tg-panel_ok,
.tg-panel.theme4 .tg-panel_ok{
	display: none;
}
.tg-panel.theme1 .tg-panel_closeIcon,
.tg-panel.theme3 .tg-panel_closeIcon{
	display: none;
}
.tg-panel.theme1 .tg-panel_main,
.tg-panel.theme3 .tg-panel_main{
	padding-bottom: 1.32rem;
}
.tg-panel.theme0 .tg-panel_container,
.tg-panel.theme1 .tg-panel_container{
	height: 61.8%;
}
.tg-panel.theme4 .tg-panel_container{
    height: 78%;
}
.tg-panel.theme3 .tg-panel_container,
.tg-panel.theme4 .tg-panel_container{
	min-height: 38px;
}
.tg-panel_main{
	overflow: auto;
	height: 100%;
}
</style>